/**
 * Created by Kris Frenz on 8/1/17.
 */

import $ from 'jquery';

class StickyNav {

	/**
	 * Constructor
	 *
	 * @param element
	 * @param options
	 */
	constructor(element, options) {
		//	const $element = $(element);
		const config = $.extend({
			offset: [
				'.mainnav'
			]
		}, options);

		if ($(element).length === 0) {
			return;
		}

		this.init(element, config);
		document.addEventListener('scroll', () => {
			const scrollPos = this.getScrollOffsetOnScroll();
			const stickyNavTrigger = this.getElOffset();

			this.setStickyNav(stickyNavTrigger, scrollPos);
		});
	}

	/**
	 * Initializes Stuff
	 *
	 */

	init() {
		const elOffsetTop = this.getElOffset();
		const scrollOffset = this.getScrollOffset();

		this.setStickyNav(elOffsetTop, scrollOffset);
	}

	/**
	 *
	 * @param elOffsetTop
	 * @param scrollOffset
	 */

	setStickyNav(elOffsetTop, scrollOffset) {
		const mainNav = document.getElementsByClassName('mainnav');

		if (scrollOffset > elOffsetTop) {
			mainNav[0].classList.add('is-fixed');
		} else {
			mainNav[0].classList.remove('is-fixed');
		}
	}

	/**
	 * Gets Header Height
	 * Dinamically
	 *
	 * @returns {number}
	 */

	getElOffset() {
		const element = document.getElementsByClassName('cmp-03-benefits');
		const height = element[0].offsetHeight / 2;
		const top = element[0].offsetTop - height;

		return top;
	}

	/**
	 * Gets Initial value
	 * of topPosition
	 *
	 * @returns {number}
	 */

	getScrollOffset() {

		let topPosition = 0;

		if (typeof window.pageYOffset !== 'undefined') {
			topPosition = window.pageYOffset;

		} else if (typeof document.documentElement.scrollTop !== 'undefined' && document.documentElement.scrollTop > 0) {
			topPosition = document.documentElement.scrollTop;

		} else if (typeof document.body.scrollTop !== 'undefined') {
			topPosition = document.body.scrollTop;
		}

		return topPosition;
	}

	/**
	 *  Updates topPosition
	 *  on Scroll
	 *
	 * @returns {number}
	 */

	getScrollOffsetOnScroll() {

		return this.getScrollOffset();
	}

}

export default StickyNav;



// WEBPACK FOOTER //
// ./js/modules/stickyNav.js